const INTERACTIVE_SELECTOR = "a, button, input, label, select, textarea"

// Un clic n'importe où sur la carte bascule son état lu / non lu ; les actions
// explicites (lien « Voir », bouton du formulaire) gardent leur comportement.
const onRowClick = (event) => {
  if (event.defaultPrevented) return
  if (event.button != null && event.button !== 0) return
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return

  const row = event.target.closest?.("[data-admin-notification-toggle]")
  if (!row) return
  if (event.target.closest?.(INTERACTIVE_SELECTOR)) return

  const form = row.querySelector("[data-admin-notification-toggle-form]")
  if (!form) return

  if (typeof form.requestSubmit === "function") {
    form.requestSubmit()
  } else {
    form.submit()
  }
}

export const initBackofficeNotificationRows = () => {
  if (document.documentElement.dataset.backofficeNotificationRowsInit === "true") return
  document.documentElement.dataset.backofficeNotificationRowsInit = "true"

  document.addEventListener("click", onRowClick)
}
